/** Thread roles that must not be overwritten by global operator chat UI mode. */
export function isProtectedChatThreadUiRole(uiRole: string | undefined): boolean {
  return uiRole === 'prospector';
}
